// File: src/slices/IBSidSlice.js (recommended path)
// import { createSlice } from '@reduxjs/toolkit';

// const IBSid = createSlice({
//   name: "ibsID",
//   initialState: {
//     ibs_id: null,
//   },
//   reducers: {
//     getIbsId(state, action) {
//       state.ibs_id = action.payload;
//     },
//   },
// });

// export const { getIbsId } = IBSid.actions;
// export default IBSid.reducer;

import { createSlice } from '@reduxjs/toolkit'
const ibsid = createSlice({
  name:"ibsid",
  initialState: {
    isToggled: null,
  },
  reducers:{
    ibsID: (state,action) => {
        state.isToggled = action.payload;
      },
  }
}) 
export default ibsid.reducer;
export const {ibsID} = ibsid.actions;


// import { createSlice } from '@reduxjs/toolkit'
// const displaychannellogos = createSlice({
//   name:"displaychannellogos",
//   initialState: {
//     isToggled: "",
//   },
//   reducers:{
//     displaychannelLogos: (state,action) => {
//         state.isToggled = action.payload;
//       },
//   }
// }) 
// export default displaychannellogos.reducer;
// export const {displaychannelLogos} = displaychannellogos.actions;